export interface WidgetSettings {
  // カラー設定
  primaryColor: string;
  secondaryColor: string;
  
  // 位置設定（デスクトップ）
  offsetX: number;
  offsetY: number;
  desktopPosition: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left' | 'custom';
  
  // 位置設定（モバイル）
  mobileOffsetX: number;
  mobileOffsetY: number;
  mobilePosition: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left' | 'custom';
  
  // サイズ設定
  width: number;
  height: number;
  bubbleSize: number;
  mobileBubbleSize: number;
  
  // アイコンサイズ
  avatarIconSize: number;
  uiIconSize: number;
  
  // フォントサイズ
  headerFontSize: number;
  messageFontSize: number;
  inputFontSize: number;
  
  // レイアウト設定
  headerHeight: number;
  footerHeight: number;
  
  // アイコン設定
  bubbleIcon: 'bubble1' | 'bubble2' | 'bubble3' | 'bubble4' | 'custom';
  bubbleIconUrl?: string;
  userIcon: 'user1' | 'user2' | 'user3' | 'user4' | 'custom';
  userIconUrl?: string;
  botIcon: 'bot1' | 'bot2' | 'bot3' | 'bot4' | 'custom';
  botIconUrl?: string;
  sendIcon: 'send1' | 'send2' | 'send3' | 'send4' | 'custom';
  sendIconUrl?: string;
  closeIcon: 'close1' | 'close2' | 'close3' | 'close4' | 'custom';
  closeIconUrl?: string;
  
  // その他設定
  bubbleShape?: 'circle' | 'square';
  headerText?: string;
  initialMessage?: string;
  useSafeArea?: boolean;
  avoidSystemUI?: boolean;
  
  // API設定
  apiEndpoint?: string;
  difyApiKey?: string;
}

export interface ChatMessage {
  id: string;
  content: string;
  role: 'user' | 'assistant';
  timestamp: number;
}

export interface DifyApiRequest {
  query: string;
  response_mode: 'blocking' | 'streaming';
  user: string;
  conversation_id?: string;
  inputs?: Record<string, any>;
}

export interface DifyApiResponse {
  answer: string;
  conversation_id: string;
  created_at: number;
}

export interface ApiError {
  error: string;
  status: number;
}

export const DEFAULT_SETTINGS: WidgetSettings = {
  primaryColor: '#3182ce',
  secondaryColor: '#f5f5f5',
  offsetX: 20,
  offsetY: 20,
  desktopPosition: 'bottom-right',
  mobileOffsetX: 20,
  mobileOffsetY: 20,
  mobilePosition: 'bottom-right',
  width: 400,
  height: 600,
  bubbleSize: 60,
  mobileBubbleSize: 60,
  avatarIconSize: 45,
  uiIconSize: 24,
  headerFontSize: 16,
  messageFontSize: 14,
  inputFontSize: 14,
  headerHeight: 70,
  footerHeight: 70,
  bubbleShape: 'circle',
  bubbleIcon: 'bubble1',
  userIcon: 'user1',
  botIcon: 'bot1',
  sendIcon: 'send1',
  closeIcon: 'close1',
  headerText: 'チャットサポート',
  initialMessage: 'こんにちは！何かお手伝いできることはありますか？',
  useSafeArea: true,
  avoidSystemUI: true,
  apiEndpoint: 'auto'
};

export const MESSAGES = {
  ja: {
    placeholder: 'メッセージを入力してください...',
    send: '送信',
    close: '閉じる',
    error_network: 'ネットワークエラーが発生しました',
    error_api: 'APIエラーが発生しました',
    typing: '入力中...',
    minimize: '最小化',
    expand: '展開'
  }
};